import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import './ContractorApplication.css';

// Create a separate axios instance for public API calls without auth interceptor
const publicApi = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

const ContractorApplication = () => {
  const [formData, setFormData] = useState({
    company_name: '',
    representative_name: '',
    business_number: '',
    resident_number: '',
    login_id: '',
    password: '',
    email: '',
    phone: '',
    address: '',
    specialties: [],
    introduction: '',
    agreement_accepted: false
  });

  const [signatureData, setSignatureData] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [idAvailable, setIdAvailable] = useState(null);
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [applicationId, setApplicationId] = useState(null);
  const [warrantyPeriod, setWarrantyPeriod] = useState('3'); // 하자보수 기간 (년) - 기본값 3년

  const canvasRef = useRef(null);
  const isDrawing = useRef(false);

  const specialtyOptions = [
    '건축공사', '인테리어', '단열공사', '방수공사', '방수.단열',
    '철거공사', '원상복구', '철거.복구', '콘크리트폴리싱',
    '에폭시 바닥 시공', '우레탄 바닥 시공', '셀프레벨링 시공',
    '라인마킹 / 도색', '바닥 보수 공사', '부분공사'
  ];

  const getAgreementText = () => `
제1조 (목적)
본 계약은 건기넷(이하 "본사")과 시공점(이하 "계약자") 간의 건축/시공 중계 서비스 이용에 관한 권리와 의무를 규정함을 목적으로 한다.

제2조 (중계 수수료 및 정산)
1. 계약자는 본사가 중계한 공사 계약금액의 사전 협의된 비율을 수수료로 지급한다.
2. 계약자는 고객으로부터 1차 계약금 수령 후 3일 이내에 본사에 수수료를 정산해야 한다.
3. 정산 기한을 초과할 경우, 법정 최고 이자율(연 24%)을 적용한 지연이자를 부담한다.
4. 1회 이상 정산 지연 시 본사는 계약을 즉시 해지할 수 있다.
5. 본사는 사전 통지 없이 수수료율을 변경할 수 있다.

제3조 (계약자의 의무)
1. 계약자는 성실한 시공과 품질 보증의 의무를 진다.
2. 시공 완료 후 ${warrantyPeriod}년간 하자보수 책임을 진다.
3. 고객 클레임 발생 시 12시간 내 대응해야 한다.
4. 시공 진행 상황을 본사에 정확하게 보고해야 한다.
5. 본사가 요구하는 모든 문서를 즉시 제출해야 한다.

제4조 (허위 보고 및 계약 위반)
1. 계약자가 시공 상황에 대해 허위 보고를 할 경우, 1회 적발 시 즉시 계약 해지된다.
2. 허위 보고로 인한 모든 손해에 대해 민·형사상 책임을 진다.
3. 특히 "일을 완료했는데 안 했다"고 주장하는 경우:
   - 즉시 계약 해지
   - 해당 건의 수수료 전액 환수
   - 손해배상 청구 (실손해액의 5배)
   - 형사 고발 (사기죄 적용)
4. 본사는 모든 증거자료를 수집·보관하여 법적 대응에 활용한다.

제5조 (품질 보증)
1. 계약자는 모든 시공에 대해 ${warrantyPeriod}년의 하자보수 기간을 보증한다.
2. 하자 발생 시 24시간 내 현장 방문하여 보수해야 한다.
3. 중대한 하자 발생 시 향후 3년간 본사 중계 서비스 이용이 제한된다.

제6조 (계약 해지)
다음 각 호에 해당하는 경우 본사는 즉시 계약을 해지할 수 있다.
1. 허위 보고 1회 적발
2. 수수료 정산 1회 이상 지연
3. 고객 클레임 미대응 2회 이상
4. 중대한 시공 하자 발생
5. 고객 정보 무단 활용
6. 본사 지시사항 불이행

제7조 (손해배상)
1. 계약자의 고의 또는 과실로 인한 손해는 계약자가 전액 배상한다.
2. 허위 보고의 경우 실손해액의 5배를 배상한다.
3. 본사의 명예를 실추시킨 경우 1억원 이상의 손해배상을 청구할 수 있다.
4. 고객 정보 유출 시 건당 5천만원의 손해배상을 청구한다.

제8조 (개인정보 보호)
1. 계약자는 업무상 취득한 고객 정보를 무단으로 활용할 수 없다.
2. 위반 시 개인정보보호법에 따라 처벌받으며, 본사는 별도의 손해배상을 청구한다.
3. 고객 정보는 계약 종료 후 즉시 폐기해야 한다.

제9조 (관할권 및 준거법)
1. 본 계약과 관련한 모든 분쟁은 본사 소재지 관할 법원에서 해결한다.
2. 본사는 계약자에 대한 모든 법적 조치를 취할 권한을 가진다.
3. 계약자는 본사의 결정에 이의를 제기할 수 없다.

제10조 (재의뢰 관리)
1. 본사를 통해 성사된 고객이 계약자에게 직접 재의뢰하는 경우:
   - 계약자는 즉시 본사에 통보해야 한다.
   - 사전 통보 없이 직접 계약 시 계약금의 50%를 위약금으로 지급한다.
   - 본사와 협의 후 정해진 수수료를 납부해야 한다.
2. 고객 정보를 무단 활용한 영업 행위 적발 시:
   - 즉시 계약 해지
   - 향후 5년간 입점 금지
   - 민형사상 책임 추궁

제11조 (기타)
1. 본 계약에 명시되지 않은 사항은 본사와 계약자가 상호 협의하여 결정한다.
2. 계약자는 본 계약의 모든 조항에 대해 완전히 이해하고 동의한다.
  `;

  useEffect(() => {
    initCanvas();
  }, []);

  const initCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    // 모바일 디바이스 체크
    const isMobile = window.innerWidth <= 640;
    if (isMobile) {
      // 모바일에서는 화면 너비의 90%를 사용
      const containerWidth = Math.min(window.innerWidth * 0.9, 600);
      canvas.width = containerWidth;
    }

    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSpecialtyChange = (specialty) => {
    setFormData(prev => ({
      ...prev,
      specialties: prev.specialties.includes(specialty)
        ? prev.specialties.filter(s => s !== specialty)
        : [...prev.specialties, specialty]
    }));
  };

  const handleSelectAllSpecialties = () => {
    if (formData.specialties.length === specialtyOptions.length) {
      setFormData(prev => ({ ...prev, specialties: [] }));
    } else {
      setFormData(prev => ({ ...prev, specialties: [...specialtyOptions] }));
    }
  };

  const handleAgreementChange = (e) => {
    setFormData(prev => ({
      ...prev,
      agreement_accepted: e.target.checked
    }));
  };

  const checkLoginId = async () => {
    if (!formData.login_id) {
      setErrors(prev => ({ ...prev, login_id: '로그인 ID를 입력해주세요.' }));
      return;
    }

    try {
      const response = await publicApi.get('/contractor-applications/check-login-id', {
        params: { login_id: formData.login_id }
      });
      setIdAvailable(response.data.available);
      if (!response.data.available) {
        setErrors(prev => ({ ...prev, login_id: '이미 사용중인 ID입니다.' }));
      }
    } catch (error) {
      console.error('ID 확인 오류:', error);
      setErrors(prev => ({ ...prev, login_id: 'ID 확인 중 오류가 발생했습니다.' }));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length + attachments.length > 20) {
      setErrors(prev => ({ ...prev, files: '최대 20개까지 첨부 가능합니다.' }));
      return;
    }
    setAttachments(prev => [...prev, ...files]);
    setErrors(prev => ({ ...prev, files: '' }));
  };

  const removeFile = (index) => {
    setAttachments(prev => prev.filter((_, i) => i !== index));
  };

  // Canvas 서명 관련 함수들
  const startDrawing = (e) => {
    isDrawing.current = true;
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    
    const x = e.type.includes('mouse') ? e.clientX - rect.left : e.touches[0].clientX - rect.left;
    const y = e.type.includes('mouse') ? e.clientY - rect.top : e.touches[0].clientY - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const draw = (e) => {
    if (!isDrawing.current) return;
    
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    
    const x = e.type.includes('mouse') ? e.clientX - rect.left : e.touches[0].clientX - rect.left;
    const y = e.type.includes('mouse') ? e.clientY - rect.top : e.touches[0].clientY - rect.top;
    
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#000';
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const stopDrawing = () => {
    if (!isDrawing.current) return;
    isDrawing.current = false;
    
    const canvas = canvasRef.current;
    if (hasSignature()) {
      setSignatureData(canvas.toDataURL());
    }
  };

  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setSignatureData('');
  };

  const hasSignature = () => {
    const canvas = canvasRef.current;
    if (!canvas) return false;
    
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    
    // Check for non-white pixels (서명이 있는지 확인)
    for (let i = 0; i < data.length; i += 4) {
      // RGB 값이 모두 255(흰색)가 아니면 서명이 있는 것
      if (data[i] !== 255 || data[i + 1] !== 255 || data[i + 2] !== 255) {
        return true;
      }
    }
    return false;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.company_name) newErrors.company_name = '업체명을 입력해주세요.';
    if (!formData.representative_name) newErrors.representative_name = '대표자명을 입력해주세요.';
    if (!formData.resident_number) newErrors.resident_number = '주민등록번호를 입력해주세요.';
    if (!formData.login_id) newErrors.login_id = '로그인 ID를 입력해주세요.';
    if (!formData.password) newErrors.password = '비밀번호를 입력해주세요.';
    if (!formData.email) newErrors.email = '이메일을 입력해주세요.';
    if (!formData.phone) newErrors.phone = '연락처를 입력해주세요.';
    if (!formData.address) newErrors.address = '주소를 입력해주세요.';
    if (formData.specialties.length === 0) newErrors.specialties = '최소 1개 이상의 전문분야를 선택해주세요.';
    if (!formData.agreement_accepted) newErrors.agreement = '약관에 동의해주세요.';
    if (!hasSignature()) newErrors.signature = '서명을 해주세요.';
    if (idAvailable === false) newErrors.login_id = '사용할 수 없는 ID입니다.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      alert('필수 항목을 모두 입력해주세요.');
      return;
    }

    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      
      // 기본 정보
      Object.keys(formData).forEach(key => {
        if (key === 'specialties') {
          formDataToSend.append(key, JSON.stringify(formData[key]));
        } else {
          formDataToSend.append(key, formData[key]);
        }
      });

      // 약관 텍스트와 서명 추가
      formDataToSend.append('agreement_text', getAgreementText());
      
      // 캔버스에서 서명 데이터 가져오기
      const canvas = canvasRef.current;
      if (canvas && hasSignature()) {
        formDataToSend.append('signature_data', canvas.toDataURL());
      }

      // 파일 첨부
      attachments.forEach(file => {
        formDataToSend.append('attachments', file);
      });

      const response = await publicApi.post('/contractor-applications/submit', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        setApplicationId(response.data.applicationId);
        setShowSuccess(true);
      }
    } catch (error) {
      console.error('신청 제출 오류:', error);
      alert(error.response?.data?.error || '신청 제출 중 오류가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (showSuccess) {
    return (
      <div className="application-success">
        <div className="success-container">
          <div className="success-icon">✅</div>
          <h1>입점 신청이 완료되었습니다!</h1>
          
          <div className="success-info">
            <p className="application-number">
              신청번호: <strong>#{applicationId}</strong>
            </p>
            <p>영업일 기준 1-2일 이내에</p>
            <p>담당자가 연락드릴 예정입니다.</p>
            <div className="login-info">
              <p className="login-title">📌 승인 완료 후</p>
              <p>신청하신 <strong>아이디</strong>와 <strong>비밀번호</strong>로</p>
              <p>로그인하실 수 있습니다.</p>
            </div>
          </div>

          <div className="success-actions">
            <a 
              href="https://play.google.com/store/apps/details?id=com.geongi.kr.myapp"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-app"
            >
              <span className="btn-icon">📱</span>
              건기 앱 설치하기
            </a>
          </div>

          <div className="contact-info">
            <p>문의사항이 있으신가요?</p>
            <p className="contact-number">
              <span className="contact-icon">📞</span>
              <strong>010-2799-8599</strong>
            </p>
            <p className="contact-hours">평일 09:00 - 18:00</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contractor-application">
      <div className="application-header">
        <h1>건기 입점 계약서</h1>
      </div>

      <form onSubmit={handleSubmit} className="application-form">
        {/* 기본 정보 */}
        <div className="form-section">
          <h2>기본 정보</h2>
          
          <div className="form-grid">
            <div className="form-group">
              <label className="required">업체명</label>
              <input
                type="text"
                name="company_name"
                value={formData.company_name}
                onChange={handleInputChange}
                placeholder="업체명을 입력하세요"
              />
              {errors.company_name && <span className="error">{errors.company_name}</span>}
            </div>

            <div className="form-group">
              <label className="required">대표자명</label>
              <input
                type="text"
                name="representative_name"
                value={formData.representative_name}
                onChange={handleInputChange}
                placeholder="대표자명을 입력하세요"
              />
              {errors.representative_name && <span className="error">{errors.representative_name}</span>}
            </div>

            <div className="form-group">
              <label>사업자등록번호</label>
              <input
                type="text"
                name="business_number"
                value={formData.business_number}
                onChange={handleInputChange}
                placeholder="사업자등록번호 (선택)"
              />
            </div>

            <div className="form-group">
              <label className="required">주민등록번호</label>
              <input
                type="text"
                name="resident_number"
                value={formData.resident_number}
                onChange={handleInputChange}
                placeholder="주민등록번호를 입력하세요"
              />
              {errors.resident_number && <span className="error">{errors.resident_number}</span>}
            </div>
          </div>
        </div>

        {/* 계정 정보 */}
        <div className="form-section">
          <h2>계정 정보</h2>
          
          <div className="form-grid">
            <div className="form-group">
              <label className="required">로그인 ID</label>
              <div className="input-with-button">
                <input
                  type="text"
                  name="login_id"
                  value={formData.login_id}
                  onChange={handleInputChange}
                  placeholder="로그인 ID"
                />
                <button type="button" onClick={checkLoginId} className="btn-check">
                  중복확인
                </button>
              </div>
              {idAvailable === true && <span className="success">✓ 사용 가능한 ID입니다.</span>}
              {errors.login_id && <span className="error">{errors.login_id}</span>}
            </div>

            <div className="form-group">
              <label className="required">비밀번호</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="비밀번호"
              />
              {errors.password && <span className="error">{errors.password}</span>}
            </div>

            <div className="form-group">
              <label className="required">이메일</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="이메일 주소"
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label className="required">연락처</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="연락처 (예: 010-1234-5678)"
              />
              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>
          </div>

          <div className="form-group full-width">
            <label className="required">주소</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="상세 주소를 입력하세요"
            />
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        {/* 전문 분야 - 개선된 UI */}
        <div className="form-section">
          <h2>전문 분야</h2>
          <p className="section-description">전문 시공 분야 선택 (복수 선택 가능)</p>
          
          <div className="specialty-grid">
            {specialtyOptions.map(specialty => (
              <label key={specialty} className={`specialty-item ${formData.specialties.includes(specialty) ? 'selected' : ''}`}>
                <input
                  type="checkbox"
                  checked={formData.specialties.includes(specialty)}
                  onChange={() => handleSpecialtyChange(specialty)}
                />
                <span className="specialty-label">{specialty}</span>
                {formData.specialties.includes(specialty) && <span className="check-mark">✓</span>}
              </label>
            ))}
          </div>
          {errors.specialties && <span className="error">{errors.specialties}</span>}
          <div className="selected-count">
            선택된 분야: {formData.specialties.length}개
          </div>
        </div>

        {/* 간단 소개 */}
        <div className="form-section">
          <h2>간단 소개</h2>
          <div className="form-group full-width">
            <textarea
              name="introduction"
              value={formData.introduction}
              onChange={handleInputChange}
              rows="4"
              placeholder="귀사의 강점과 특징을 간단히 소개해주세요 (선택사항)"
            />
          </div>
        </div>

        {/* 하자보수 기간 선택 */}
        <div className="form-section">
          <h2>하자보수 책임 기간</h2>
          <div className="warranty-period-selector">
            <p style={{marginBottom: '20px', color: '#475569', fontWeight: '600'}}>
              시공 완료 후 하자보수 책임 기간을 선택하세요:
            </p>
            <div className="warranty-selector">
              {[1, 2, 3].map(year => (
                <button
                  key={year}
                  type="button"
                  className={`warranty-option ${warrantyPeriod == year ? 'selected' : ''}`}
                  onClick={() => setWarrantyPeriod(year.toString())}
                >
                  {year}년
                </button>
              ))}
            </div>
            <p className="warranty-note">
              ※ 선택한 기간 동안 하자보수 의무가 발생하며, 계약서에 명시됩니다.
            </p>
          </div>
        </div>

        {/* 첨부 파일 */}
        <div className="form-section">
          <h2>첨부 파일</h2>
          <div className="form-group full-width">
            <label>사업자등록증, 자격증, 시공사례 등 (최대 20개)</label>
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              accept="image/*,application/pdf"
            />
            {attachments.length > 0 && (
              <div className="file-list">
                {attachments.map((file, index) => (
                  <div key={index} className="file-item">
                    <span>{file.name}</span>
                    <button type="button" onClick={() => removeFile(index)}>삭제</button>
                  </div>
                ))}
              </div>
            )}
            {attachments.length >= 15 && (
              <p className="file-warning">현재 {attachments.length}개 첨부됨 (최대 20개)</p>
            )}
            {errors.files && <span className="error">{errors.files}</span>}
          </div>
        </div>

        {/* 입점 계약 조항 */}
        <div className="form-section">
          <h2>입점 계약 조항</h2>
          <div className="agreement-box">
            <pre>{getAgreementText()}</pre>
          </div>
          
          <div className="agreement-check">
            <label>
              <input
                type="checkbox"
                checked={formData.agreement_accepted}
                onChange={handleAgreementChange}
              />
              <span>위 계약 조항을 모두 읽었으며, 이에 동의함.</span>
            </label>
            {errors.agreement && <span className="error">{errors.agreement}</span>}
          </div>
        </div>

        {/* 전자 서명 */}
        <div className="form-section">
          <h2>전자 서명</h2>
          <p className="section-description">아래 공간에 서명해주세요</p>
          
          <div className="signature-container">
            <canvas
              ref={canvasRef}
              width={600}
              height={200}
              className="signature-canvas"
              onMouseDown={startDrawing}
              onMouseMove={draw}
              onMouseUp={stopDrawing}
              onMouseLeave={stopDrawing}
              onTouchStart={startDrawing}
              onTouchMove={draw}
              onTouchEnd={stopDrawing}
            />
            <button type="button" onClick={clearSignature} className="btn-clear">
              서명 지우기
            </button>
          </div>
          {errors.signature && <span className="error">{errors.signature}</span>}
        </div>

        {/* 제출 버튼 */}
        <div className="form-actions">
          <button 
            type="submit" 
            className="btn-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? '제출 중...' : '입점 신청하기'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContractorApplication;